import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import { Container, ContentWithPaddingXl } from "content/misc/Layouts";
import Hero from "content/components/menu.js";
import TOC from "content/components/terms.js"
import Footer from "content/components/footer.js";

export default ({ headingText = "Terms And Condition" }) => {
  return (
    <AnimationRevealPage>
      <Hero />
      <Container>
        <ContentWithPaddingXl>
          <TOC />
        </ContentWithPaddingXl>
      </Container>
      <Footer />
    </AnimationRevealPage>
  );
};
